import { GRID_VIEW, LIST_VIEW } from '.';

export const pageTypes = {
  home: 'home',
  categoricalProduct: 'categorical-product',
  brandWiseProduct: 'brand-wise-product',
  productDetail: 'product-detail',
  comparison: 'product-comparison',
  cart: 'shopping-cart',
  checkout: 'checkout',
  myOrder: 'my-order',
  other: 'other',
};

export const skeletonTypes = {
  productCardGridView: GRID_VIEW,
  productCardListView: LIST_VIEW,
};

export const cardViewTypes = {
  list: LIST_VIEW,
  grid: GRID_VIEW,
};

export const screenTypes = {
  extraLarge: 1280,
  large: 1024,
  medium: 768,
  small: 640,
};

// export const STORE_TYPES = {
//   HOME_APPLIENCES: 'Home appliances',
//   APPLIANCE_STORE: 'Appliance store',
// };

export const STORE_TYPES = {
  STORE: 'Store',
  SERVICE_CENTER: 'Service Center',
};

export const LOCATION_PERMISSION_STATE = {
  PROMPT: 'prompt',
  GRANTED: 'granted',
};

export const LOCATION_FILTER_KEY = {
  DISTRICT: { id: 'district', name: 'District' },
  DIVISION: { id: 'division', name: 'Division' },
  STORE_TYPE: { id: 'store_type', name: 'Store Type' },
  DISTANCE: { id: 'distance', name: 'Distance' },
};

export const addAddressFormTypes = {
  shipping: 'add-shipping-address-form',
  billing: 'add-billing-address-form',
};

export const cartProductCardTypes = {
  checkoutModal: 'checkout-modal',
  shoppingCart: 'shopping-cart',
};

export const statusTypes = {
  idle: 'idle',
  loading: 'loading',
  succeeded: 'succeeded',
  failed: 'failed',
  fetched: 'fetched',
  deleting: 'deleting',
  deleted: 'deleted',
  spinning: 'spinning',
  startSpinning: 'start-spinning',
  endSpinning: 'end-spinning',
  fetching: 'fetching',
};

export const checkoutSummaryStatusTypes = {
  init: 'init',
  update: 'update',
  place: 'place',
};

export const paymentMethodTypes = {
  online: 'ONLINE',
  onlineEmi: 'ONLINE-EMI',
  cod: 'COD', // cash on delivery
};

export const userTypes = {
  guest: 'guest',
  loggedIn: 'logged-in',
};

export const dateTimeFormateTypes = {
  default: 'd MMMM yyyy',
  orderDate: 'd MMM yyyy',
  promoValidDate: 'dd MMM yyyy',
  invoiceDate: 'yyyy-MM-dd',
  dateTimeHour: 'dd MMM yyyy h:mm a',
};

export const orderStatusTypes = {
  accepted: 'ACCEPTED',
  rejected: 'REJECTED',
};

export const ORDER_STATUS_TYPE = {
  unassigned: {
    statusCode: 1,
    title: 'Placed',
    status: 'unassigned',
    statusBE: 'UnAssigned',
    headerTitle: 'Order Placed',
    subTitle: `Your order has been successfully placed.\n We'll notify you once it's confirmed.\n`,
  },
  pending: {
    statusCode: 2,
    title: 'Placed',
    status: 'pending',
    statusBE: 'Pending',
    headerTitle: 'Order Placed',
    subTitle: `Your order has been successfully placed.\n We'll notify you once it's confirmed.\n`,
  },
  rejected: {
    statusCode: 3,
    title: 'Rejected',
    status: 'rejected',
    statusBE: 'Rejected',
    headerTitle: 'Order Cancelled',
    subTitle: `Your order has been canceled.\n Feel free to place a new order if needed.\n`,
  },
  orderplaced: {
    statusCode: 10,
    title: 'Placed',
    status: 'orderplaced',
    statusBE: 'Order Placed',
    headerTitle: 'Order Placed',
    subTitle: `Your order has been successfully placed.\n We'll notify you once it's confirmed.\n`,
  },

  confirmed: {
    statusCode: 11,
    title: 'Confirmed',
    status: 'confirmed',
    statusBE: 'Confirmed',
    headerTitle: 'Order Confirmed',
    subTitle: `Your order is confirmed and being processed.\n We'll update on the delivery.\n`,
  },
  readyToShip: {
    statusCode: 12,
    title: 'Confirmed',
    status: 'readyToShip',
    statusBE: 'Ready To Ship',
    headerTitle: 'Order Confirmed',
    subTitle: `Your order is confirmed and being processed.\n We'll update on the delivery.\n`,
  },
  shipped: {
    statusCode: 13,
    title: 'Confirmed',
    status: 'shipped',
    statusBE: 'Shipped',
    headerTitle: 'Order Confirmed',
    subTitle: `Your order is confirmed and being processed.\n We'll update on the delivery.\n`,
  },
  delivered: {
    statusCode: 99,
    title: 'Delivered',
    status: 'delivered',
    statusBE: 'Delivered',
    headerTitle: 'Order Delivered',
    subTitle: `Your order has been delivered!\n We hope you enjoy your new purchase.\n`,
  },
  canceled: {
    statusCode: 100,
    title: 'Cancelled',
    status: 'canceled',
    statusBE: 'Canceled',
    headerTitle: 'Order Cancelled',
    subTitle: `We regret to inform you that your order has been cancelled.\n
Feel free to place a new order at your convenience.\n`,
  },
  cancelRequested: {
    statusCode: 101,
    title: 'Cancellation Pending',
    status: 'cancelRequested',
    statusBE: 'CancelRequested',
    headerTitle: 'Cancellation Pending',
    subTitle: `Your cancellation request is under review.\n`,
  },
};

export const CANCEL_ORDER_STEPS_MESSAGES = {
  COD: {
    key: 'cod',
    headerTitle: 'Order Cancelled',
    subTitle: `We regret to inform you that your order has been cancelled.\n Feel free to place a new order at your convenience.\n`,
  },
  ONLINE: {
    key: 'online',
    subTitle: `We regret to inform you that your order has been cancelled.\n A refund has been initiated.\nNote your bank may take 3-10 business days to process it.\n Feel free to place a new order at your convenience.\n`,
  },
  'ONLINE-EMI': {
    key: 'online',
    subTitle: `We regret to inform you that your order has been cancelled.\n A refund has been initiated.\nNote your bank may take 3-10 business days to process it.\n Feel free to place a new order at your convenience.\n`,
  },
};

export const CANCEL_ORDER_ONLINE_MESSAGES = {
  cancelRequested: {
    statusCode: 101,
    title: 'Cancellation Pending',
    status: 'cancelRequested',
    statusBE: 'CancelRequested',
    headerTitle: 'Cancellation Pending',
    subTitle: `Your cancellation request is under review`,
  },
  canceled: {
    statusCode: 100,
    title: 'Cancled',
    status: 'cancelled',
    statusBE: 'Cancelled',
    headerTitle: 'Cancellation Approved',
    subTitle: `Your cancellation is approved, and a refund has been initiated.\n Note your bank may take 3-10 business days to process it.`,
  },
};

export const REFUND_INITIATOR = {
  user: {
    id: 1,
    type: 'User',
  },
  singer: {
    id: 2,
    type: 'Singer',
  },
};

export const ORDER_CANCELATION_REASONS = [
  {
    id: 1,
    name: {
      en: 'Ordered By Mistake',
    },
  },
  {
    id: 2,
    name: {
      en: 'Delivery Taking Too Long',
    },
  },
  {
    id: 3,
    name: {
      en: 'Found A Better Deal',
    },
  },
  {
    id: 4,
    name: {
      en: 'Item No Longer Needed',
    },
  },
  {
    id: 5,
    name: {
      en: 'Payment Or Address Issue',
    },
  },
  {
    id: 6,
    name: {
      en: 'Others',
    },
  },
];

export const PAYMENT_METHOD = {
  ONLINE: { key: 'online', title: 'Online Payment', fromBE: 'ONLINE' },
  'ONLINE-EMI': {
    key: 'online-emi',
    title: 'Online EMI Payment',
    fromBE: 'ONLINE-EMI',
  },
  COD: { key: 'cod', title: 'Cash on Delivery', fromBE: 'COD' },
};

export const CARD_TYPE = {
  visa: 'Visa',
  mastercard: 'mastercard',
  amex: 'amex',
  upay: 'upay',
  dinersclub: 'dinersclub',
  citytouch: 'citytouch',
  mtb: 'mtb',
  bkashcheckout: 'bkashcheckout',
  rocket: 'rocket',
  nagad: 'nagad',
  nexus: 'nexus',
  tapnpay: 'tapnpay',
  okwallet: 'okwallet',
  mycash: 'mycash',
  meghna: 'meghna',
  mcash: 'mcash',
  aibl: 'aibl',
  bankasianetban: 'bankasianetban',
  ibblnetbank: 'ibblnetbank',
  ipay: 'ipay',
  cellfin: 'cellfin',
};

export const DEFAULT_ORDER_STEPS = [
  { key: 1, label: 'Order Placed', date: '', isActive: false },
  { key: 2, label: 'Order Confirmed', date: '', isActive: false },
  { key: 3, label: 'Order Delivered', date: '', isActive: false },
];

export const STORE_PICKUP_ORDER_STEPS = [
  { key: 1, label: 'Order Placed', date: '', isActive: false },
  { key: 2, label: 'Ready for Pickup', date: '', isActive: false },
  { key: 3, label: 'Order Collected', date: '', isActive: false },
];

export const CANCEL_ORDER_STEPS = [
  { key: 1, label: 'Cancellation Pending', date: '', isActive: false },
  { key: 2, label: 'Cancellation Approved', date: '', isActive: false },
];

export const TAB_MENU = [
  {
    value: 'ongoing',
    label: 'Ongoing',
    url: '/my-orders?tab=ongoing',
  },
  {
    value: 'past',
    label: 'Completed',
    url: '/my-orders?tab=past',
  },
];

export const billingAddressActionTypes = {
  create: 'create',
  edit: 'edit',
};

export const offerTypes = {
  promoCode: 'promo-code',
  couponCode: 'coupon-code',
  none: 'none',
};

export const orderStateTypes = {
  idle: 'idle', // initial page
  init: 'init',
  update: 'update',
  place: 'place',
};

export const orderCheckoutTypes = {
  normal: 'normal',
  buyNow: 'buy-now',
};

export const brandCardTypes = {
  top: 'top-brand',
  other: 'other-brand',
};

export const imageTypes = {
  wide: 'wide',
  tall: 'tall',
  square: 'square',
  icon: 'icon',
  bannerDesktop: 'banner-desktop',
  bannerMobile: 'banner-mobile',
};

export const SORT_BY_ITEMS = [
  {
    id: 'default',
    name: 'Default',
    key: 'default',
  },
  {
    id: 'priceLowToHigh',
    name: 'price (low to high)',
    key: 'price_asc',
  },
  {
    id: 'priceHighToLow',
    name: 'price (High To Low)',
    key: 'price_desc',
  },
  {
    id: 'newestArrivals',
    name: 'newest arrivals',
    key: 'created_at_desc',
  },
  {
    id: 'customerRatingsLowToHigh',
    name: 'ratings (low to high)',
    key: 'rating_asc',
  },
  {
    id: 'customerRatingsHighToLow',
    name: 'ratings (high to low)',
    key: 'rating_desc',
  },
];

export const categoryBrandSwitchTypes = {
  categories: 'categories',
  brands: 'brands',
};

export const sliderMainClassTypes = {
  default: 'default',
  justForYou: 'just-for-you',
  threeProduct: 'three-product',
  suggestedProducts: 'suggested-products',
};

export const sliderBreakPointTypes = {
  withoutNavigationButton: 'without-navigation-button',
  withNavigationButton: 'with-navigation-button',
};

export const sliderNavigationTypes = {
  withNavigation: 'with-navigation',
  withoutNavigation: 'without-navigation',
  withNavigationCampaign: 'with-navigation-campaign',
};

export const spinTheWheelTypes = {
  icon: 'icon',
  button: 'button',
  bar: 'bar',
};

export const spinWheelActionTypes = {
  openModal: 'open-modal',
  spinningWheel: 'spinning-wheel',
};

export const loginFormHeaderTypes = {
  loginForm: 'loginForm',
  otpForm: 'otpForm',
  loginFormForSpin: 'loginFormForSpin',
};

export const spinCouponTypes = {
  percentage: 'percentage',
  amount: 'amount',
};

export const metaDataPageTypes = {
  home: 'home-page',
  others: 'other-pages',
};

export const shippingMethodTypes = {
  regular: 'regular',
  storePickup: 'store_pickup',
};

export const storeLocatorSearchTypes = {
  default: 'default',
  inStorePickup: 'in-store-pickup',
};

export const shippingMethodLabels = {
  regular: 'Standard Delivery',
  storePickup: 'In Store Pickup',
};

export const cartNameBrandTypes = {
  default: 'default',
  wishlist: 'wishlist',
};

export const shippingMethodList = {
  regular: 'Standard Delivery',
  store_pickup: 'In Store Pickup',
};

export const mediaTypes = {
  image: 'image',
  video: 'video',
  youtubeVideo: 'youtube-video',
};

export const bannerTypes = {
  default: 'default',
  homePageHero: 'home-page-hero-banner',
  brandPageHero: 'brand-page-hero-banner',
  campaignHeroBannerCarousel: 'campaign-hero-banner-carousel',
  campaignLandingHero: 'campaign-landing-hero-banner',
  homepageMarketingBannerCarousel: 'homepage-marketing-banner-carousel',
  homepageSingleMediaBannerCarousel: 'homepage-single-media-banner-carousel',
  singleBannerCarousel: 'single-banner-carousel',
  popularDeals23: 'popular-deals-2-3',
  popularDeals1: 'popular-deals-1',
  campaignFourBannerRectangle: 'campaign-four-banner-rectangle',
};
